module.exports = __webpack_public_path__ + "img/advantage2_1@2x.72e4279c.png";